import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {Regional} from "../../../shared/interface/regional";
import {IddTrainingCertificate} from "../../../shared/interface/idd-training-certificate";
import {RegionalService} from "../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AuthService} from "../../../shared/services/auth.service";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {
  IC_GENERALI,
  IC_GENERALI_LIFE,
  IC_WARTA,
  IC_WARTA_LIFE
} from "../../../shared/services/insurance-company.service";
import {IddTrainingService} from "../../../shared/services/idd-training.service";

@Component({
  selector: 'app-idd-trainings-certificates-edit',
  templateUrl: './idd-trainings-certificates-edit.component.html',
  styleUrls: ['./idd-trainings-certificates-edit.component.scss']
})
export class IddTrainingsCertificatesEditComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() iddTrainingCertificateObject?: IddTrainingCertificate;
  @Output() closeModification = new EventEmitter<any>();

  certificateForm: FormGroup;
  formErrors: any = {};
  regionalFormValid = false;
  // iddTrainingControle: FormControl;
  insuranceCompanyControl: FormControl;
  realisedAtControl: FormControl;
  realisedLifeMinutesControl: FormControl;
  realisedAssetsMinutesControl: FormControl;
  realisedGeneralMinutesControl: FormControl;
  trainingTopicControl: FormControl;
  amlControl: FormControl;
  processingRequest = false;

  constructor(
    private regionalService: RegionalService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private iddTrainingService: IddTrainingService,
  ) {
    this.certificateForm = this.fb.group({
      // iddTraining: this.iddTrainingControle = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      realisedAt: this.realisedAtControl = fb.control('', [Validators.required]),
      realisedAssetsMinutes: this.realisedAssetsMinutesControl = fb.control('', [Validators.required]),
      realisedLifeMinutes: this.realisedLifeMinutesControl = fb.control('', [Validators.required]),
      realisedGeneralMinutes: this.realisedGeneralMinutesControl = fb.control('', [Validators.required]),
      trainingTopic: this.trainingTopicControl = fb.control('', [Validators.required]),
      aml: this.amlControl = fb.control( false),
    });
  }

  ngOnInit(): void {
    this.certificateForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.regionalFormValid = this.certificateForm.valid);

    if (this.iddTrainingCertificateObject) {
       this.initialize(this.iddTrainingCertificateObject);
    } else {
      this.initialized.next(true);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initialize(iddTrainingCertificate: IddTrainingCertificate): void {
    of(iddTrainingCertificate)
      .pipe(
        delay(0),
        tap(() => {
          this.certificateForm.reset({
            // iddTraining: iddTrainingCertificate.iddTraining.uuid,
            insuranceCompany: iddTrainingCertificate.insuranceCompany.id,
            realisedAt: iddTrainingCertificate.realisedAt,
            realisedAssetsMinutes: iddTrainingCertificate.realisedAssetsMinutes,
            realisedLifeMinutes: iddTrainingCertificate.realisedLifeMinutes,
            realisedGeneralMinutes: iddTrainingCertificate.realisedGeneralMinutes,
            trainingTopic: iddTrainingCertificate.trainingTopic,
            aml: iddTrainingCertificate.aml
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  cancel(): void {
      this.closeModification.emit();
  }

  save(): void {
    if (!this.certificateForm.valid) {
      this.certificateForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.iddTrainingService.editCertificate(this.iddTrainingCertificateObject.uuid, this.certificateForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie zaktualizowano certyfikat', '', {
          duration: 2000,
        });
        this.processingRequest = false;
          this.closeModification.emit();
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.certificateForm, this.formErrors);
        }
      });
  }

  protected readonly IC_WARTA = IC_WARTA;
  protected readonly IC_WARTA_LIFE = IC_WARTA_LIFE;
  protected readonly IC_GENERALI_LIFE = IC_GENERALI_LIFE;
  protected readonly IC_GENERALI = IC_GENERALI;
}
